module.exports = __webpack_public_path__ + "img/burrito_mixto.7121f365.jpg";